<template lang="pug">
.advice-table
  HeadFixedTable(
    :columns = "currentColumns",
    :checkbox="hasCheckbox",
    :check_all="hasCheckbox",
    :checkbox_length="1000",
    :isAllChecked= "isAllChecked",
    :hasPagination = "true",
    @pageChange = "pageChange",
    :list = "currentList"
    )

    template(slot="delete-td" scope="props")
        slot(name="delete", :item="props.item")
    template(slot="status-td" scope="props")
        slot(name="status", :item="props.item")

</template>
<script>
import HeadFixedTable from '../../component/fold-table.vue'
import { BIDTYPE } from './constants.js'
import Mixin from '../mixin.js'

export default {
  mixins: [Mixin],
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isAllChecked: {
      type: Boolean,
      default: false
    },
    extendColumns: {
      type: Array,
      default() {
        return  []
      }
    },
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    list: {
      type: Array,
      default(){ 
        return [{
          keyword: "test",
          adpv: 100,
          adclick: 10,
          planId: 121,
          plan: "测试",
          group: "测试",
          bidtype: 1,
          bidprice: 20,
          suggest: 0
        }]
      }
    }
  },
  components: {
      HeadFixedTable,
  },
  data() {
    return {
      advicePriceWarning : ""
    }
  },
  computed: {
    currentList() {
      return _.map(_.concat([], this.list), item => {
        this.$set(item, 'checked', false)
        return item
      })
    },
    currentColumns() {
      let list = [{
        title: "优化关键词",
        key: "bidword",
        style: "width: 220px;",
        render: (index, value, item) => {
          return `<span title="${value}">${value}</span>`
        }
      },{
        title: "展现量",
        key: "avg7adpv"
      },{
        title: "点击量",
        key: "avg7adclick"
      },{
        title: "推广计划-推广组",
        style: "width: 300px;overflow: hidden;",
        key: "planId",
        render: (index, value, item) => {
              return item.plan + ' - ' + item.groupName
        }
      },{
        title: "匹配模式",
        key: "bidtype",
        render: (index, value, item) => {
          return _.find(BIDTYPE, {value: +value}) ? _.find(BIDTYPE, {value: +value}).label : ''
        }
      },{
        title: "当前出价(￥)",
        key: "bidprice",
        render: (index, value, item) => {
          return parseFloat(value, 10).toFixed(2)
        }
      },{
        title: "暂停理由",
        key: "reasonDesc"
      }]
      return _.concat(list, this.extendColumns)
    }
  },
  filters: {
    suggestFilter(suggest) {
      const suggestTitle = ['暂停', '开启']
      return suggestTitle[suggest]
    }
  },
  methods: {
    pageChange(list) {
      this.$emit('pageChange', list)
    }
  }
}
</script>
<style scoped>
.fold-table .btn-icon{
  padding: 0 5px;
  vertical-align: baseline;
}
.fold-table td {
  overflow: hidden;
}
.modal-bd-wrapper .modal-table-wrapper .advice-table{
    border: 1px solid #DADFE6;
    border-top: none;
}
</style>



// WEBPACK FOOTER //
// pause_advice_table.vue?2be106a9